import React from "react";
export const DEFAULT_COUNTER_STYLES = {
  width: 32,
  height: 32,
  right: 8,
  top: 8
};

export const SMALL_COUNTER_STYLES = {
  width: 28,
  height: 28,
  right: 4,
  top: 4
};

const DEFAULT_CLASSES = {
  container: "",
  counter:
    "bg-content--secondary color-primary br2 pa1 ba hairline-1 absolute br-100 items-center justify-center flex z-1",
  copy: "lh-copy fw7 flex items-center f6"
};

const CounterBezel = ({
  count,
  styles = DEFAULT_COUNTER_STYLES,
  children,
  customClasses
}) => {
  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };
  return (
    <div className={classes.container}>
      {count > 1 ? (
        <div className={classes.counter} style={styles}>
          <div className={classes.copy}>{`+${count - 1}`}</div>
        </div>
      ) : null}
      {count > 0 && children}
    </div>
  );
};
export default CounterBezel;
